<template>
  <page>
    <div :load="doInit">
          <form>
            <message :messages="messages"></message>
            <v-container fluid grid-list-lg>
              <!-- <v-card-title>
                <div class="body-2">Date Ranges</div>
              </v-card-title> -->
              <v-expansion-panels v-model="panel1" multiple>
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <div><v-icon>mdi-filter-variant</v-icon> Date Range</div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-card>
                      <v-card-text>
                        <v-container fluid grid-list-sm>
                          <v-layout row wrap>
                            <v-flex xs6>
                              <cal-picker
                                v-model="reportForm.fromDate"
                                :label="labels.fromDate"
                                v-validate="'required|checkSystemDate'"
                                :data-vv-as="labels.fromDate"
                                data-vv-name="fromDate"
                                :error-messages="errors.collect('fromDate')"
                                ref="fromDate"
                                :max="new Date()"
                              ></cal-picker>
                            </v-flex>
                            <v-flex xs6>
                              <cal-picker
                                v-model="reportForm.toDate"
                                :label="labels.toDate"
                                v-validate="'required|checkSystemDate|from_to_date:fromDate'"
                                :data-vv-as="labels.toDate"
                                data-vv-name="toDate"
                                :error-messages="errors.collect('toDate')"
                                :max="new Date()"
                              ></cal-picker>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
              <v-spacer class="mt-2"></v-spacer>
              <!-- <v-divider class="mt-3 mb-3"></v-divider>
              <v-card-title>
                <div class="body-2">Filters</div>
              </v-card-title> -->
              <v-expansion-panels v-model="panel2" multiple>
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <div><v-icon>mdi-filter-variant</v-icon> Selection Criteria</div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-card>
                      <v-card-text>
                        <v-container fluid grid-list-sm>
                          <v-layout row wrap>
                            <v-flex xs6>
                              <v-text-field
                                v-model="reportForm.branch"
                                :label="labels.branch"
                                :error-messages="errors.collect('branch')"
                                :data-vv-as="labels.branch"
                                data-vv-name="branch"
                                append-icon="mdi-magnify"
                                @click:append="doHelplist('branch')"
                                readonly
                                v-validate="'required'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs6>
                              <v-text-field
                                v-model="reportForm.dept"
                                :label="labels.dept"
                                :error-messages="errors.collect('dept')"
                                :data-vv-as="labels.dept"
                                data-vv-name="dept"
                                append-icon="mdi-magnify"
                                @click:append="doHelplist('dept')"
                                readonly
                                v-validate="'required'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs6>
                              <v-text-field
                                v-model="reportForm.polType"
                                :label="labels.polType"
                                :error-messages="errors.collect('polType')"
                                :data-vv-as="labels.polType"
                                data-vv-name="polType"
                                append-icon="mdi-magnify"
                                @click:append="doHelplist('polType')"
                                readonly
                                v-validate="'required'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs6>
                              <v-text-field
                                v-model="reportForm.fund"
                                :label="labels.fund"
                                :error-messages="errors.collect('fund')"
                                :data-vv-as="labels.fund"
                                data-vv-name="fund"
                                append-icon="mdi-magnify"
                                @click:append="doHelplist('fund')"
                                readonly
                                v-validate="'required'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs6>
                              <v-text-field
                                v-model="reportForm.acctNoSfx"
                                :label="labels.acctNoSfx"
                                :error-messages="errors.collect('acctNoSfx')"
                                :data-vv-as="labels.acctNoSfx"
                                data-vv-name="acctNoSfx"
                                append-icon="mdi-magnify"
                                @click:append="doHelplist('acctNoSfx')"
                                readonly
                                v-validate="'required'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs6>
                              <v-autocomplete
                                :items="directRIList"
                                v-model="reportForm.dri"
                                :label="labels.dri"
                                item-text="label"
                                item-value="value"
                                data-vv-name="dri"
                                :data-vv-as="labels.dri"
                                :error-messages="errors.collect('dri')"
                                v-validate="'required'"
                              ></v-autocomplete>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
              <!-- <v-divider class="mt-3 mb-3"></v-divider>
              <v-card-title>
                <div class="body-2">{{labels.sortOrder}}</div>
              </v-card-title> -->
              <v-spacer class="mt-2"></v-spacer>
              <v-expansion-panels v-model="panel3" multiple>
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <div><v-icon>mdi-filter-variant</v-icon> {{ labels.sortOrder }}</div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-card>
                      <v-card-text>
                        <v-container fluid grid-list-sm>
                          <v-layout row wrap>
                            <v-flex xs4>
                              <v-card-title>
                                <div class="body-3">Sort Order By</div>
                                <v-spacer></v-spacer>
                                <v-icon @click="doHelplist('sortOrder')">mdi-magnify</v-icon>
                              </v-card-title>
                            </v-flex>
                            <v-flex xs8>
                              <v-data-table
                                :headers="sortOrderHeader"
                                :items="items"
                                :no-data-text="noText"
                                item-key="text"
                                hide-default-footer
                                ref="sortOrder"
                              >
                                <template v-slot:item="row">
                                  <tr>
                                    <td width="50px"><v-icon class="phSortIcon">mdi-cursor-move</v-icon></td>
                                    <td>{{ row.item.text }}</td>
                                    <td>{{ row.item.subTotal ? 'Yes' : 'No' }}</td>
                                    <td>{{ row.item.pageBreak ? 'Yes' : 'No' }}</td>
                                  </tr>
                                </template>
                              </v-data-table>
                              <p v-if="items.length > 1" align="center">Hold the icon to arrange the sequence</p>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
              <v-spacer class="mt-2"></v-spacer>
              <v-expansion-panels v-model="panel4" multiple>
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <div><v-icon>mdi-settings</v-icon> Report Setting</div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-card>
                      <v-card-text>
                        <v-container fluid grid-list-sm>
                          <v-layout row wrap>
                            <v-flex xs6>
                              <v-autocomplete
                                :items="typeReportList"
                                v-model="reportForm.typeReport"
                                :label="labels.typeReport"
                                item-text="label"
                                item-value="value"
                                data-vv-name="typeReport"
                                :data-vv-as="labels.typeReport"
                                :error-messages="errors.collect('typeReport')"
                                @change="doDisplayTrans"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex xs6>
                              <v-autocomplete
                                :items="booleanList"
                                v-model="reportForm.displayTrans"
                                :label="labels.displayTrans"
                                item-text="label"
                                item-value="value"
                                data-vv-name="displayTrans"
                                :data-vv-as="labels.displayTrans"
                                :error-messages="errors.collect('displayTrans')"
                                :disabled="displayTransAE"
                              ></v-autocomplete>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
              <!-- <v-divider class="mt-3 mb-3"></v-divider> -->
            </v-container>
          </form>
      <v-spacer class="mt-3"></v-spacer>
      <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex xs12 class="pt-3">
                  <v-checkbox
                    dense
                    v-model="reportForm.rptParam"
                    :label="labels.rptParam"
                    :error-messages="errors.collect('rptParam')"
                    data-vv-name="rptParam"
                    :data-vv-as="labels.rptParam"
                    hide-details
                  ></v-checkbox>
                </v-flex>
                <v-flex xs4 class="pt-3">
                  <v-btn class="mr-2" color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
                    <v-icon left dark>mdi-file-export</v-icon>
                    Export TO
                  </v-btn>
                  <v-btn-toggle dense mandatory v-model="reportForm.format">
                    <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
                      <span>{{ format.label }}</span>
                      <v-icon :color="format.color">{{ format.icon }}</v-icon>
                    </v-btn>
                  </v-btn-toggle>
                </v-flex>
              </v-layout>
      </v-container>
      <v-dialog v-model="helplist" width="900px" persistent>
        <branch-helplist v-show="branchHelplist" :menu="menu" @close="doCloseHelpList" @doAssign="doAssign($event)"></branch-helplist>
        <dept-helplist v-show="deptHelplist" :menu="menu" @close="doCloseHelpList" @doAssign="doAssign($event)"></dept-helplist>
        <polType-helplist v-show="polTypeHelplist" :menu="menu" @close="doCloseHelpList" @doAssign="doAssign($event)"></polType-helplist>
        <fund-helplist v-show="fundHelplist" :menu="menu" @close="doCloseHelpList" @doAssign="doAssign($event)"></fund-helplist>
        <acctNoSfx-helplist v-show="suffixHelplist" :menu="menu" @close="doCloseHelpList" @doAssign="doAssign($event)"></acctNoSfx-helplist>
        <!-- clone a new array and pass it to child to prevent the array in parent from mutated by child without being aware of it -->
        <sortOrder-helplist
          v-if="sortOrderHelplist"
          :selectedList="clone(items)"
          @doSortOrderList="doSortOrderList($event)"
          @close="doClose"
        ></sortOrder-helplist>
      </v-dialog>
    </div>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import * as TableConst from '@/mixins/table'
import clone from 'clone'
import { extractMenu } from '@/utils/extract'
import { reportFormat } from '@/const/report'
import { removeTime } from '@/utils/date'
import BranchHelplist from './helplist/BranchHelplist'
import DeptHelplist from './helplist/DeptHelplist'
import PolTypeHelplist from './helplist/PolTypeHelplist'
import FundHelplist from './helplist/FundHelplist'
import AcctNoSfxHelplist from './helplist/AcctNoSfxHelplist'
import SortOrderHelplist from './helplist/SortOrderHelplist'
import Sortable from 'sortablejs'
export default {
  data() {
    return {
      labels: {
        fromDate: 'Transaction Date From*',
        toDate: 'Transaction Date To*',
        branch: 'Branch',
        dept: 'Department',
        polType: 'Policy Type',
        fund: 'Fund',
        acctNoSfx: 'Suffix',
        dri: 'Direct / RI Inwards',
        sortOrder: 'Sort Order',
        typeReport: 'Type of Report',
        displayTrans: 'Display no. of Transactions',
        rptParam: 'Print Runtime Parameters'
      },
      reportForm: {
        fromDate: null,
        toDate: null,
        branch: null,
        dept: null,
        polType: null,
        fund: null,
        acctNoSfx: null,
        dri: null,
        sortOrder: null,
        subTotal: null,
        pageBreak: null,
        typeReport: null,
        displayTrans: null,
        rptParam: true,
        format: null
      },
      sortOrderHeader: [
        { text: '', value: 'pgIcon', sortable: false },
        { text: 'Sort Order', value: 'text', sortable: false },
        { text: 'Sub Total', value: 'subTotal', sortable: false },
        { text: 'Page Break', value: 'pageBreak', sortable: false }
      ],
      supportedFormat: [],
      menu: {},
      submitting: false,
      helplist: false,
      branchHelplist: false,
      deptHelplist: false,
      polTypeHelplist: false,
      fundHelplist: false,
      suffixHelplist: false,
      sortOrderHelplist: false,
      rptHistory: false,
      noText: 'Please select a sort order',
      panel1: [0],
      panel2: [],
      panel3: [],
      panel4: [0]
    }
  },
  created() {
    // Load helplist
    this.doInit()
  },
  methods: {
    async doInit() {
      if (this.$store.state.reports.uwReports.init !== 1) {
        await this.$store.dispatch('uwReportsInit')
      }
      const apiURI = this.rptMenu.initIPR
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          if (result.data) {
            const { data } = result.data
            if (data) {
              this.supportedFormat = data.format
              this.menu = extractMenu(result.data._links)
            }
            this.reportForm.fromDate = removeTime(Date.now())
            this.reportForm.toDate = removeTime(Date.now())
            this.reportForm.branch = 'All'
            this.reportForm.dept = 'All'
            this.reportForm.polType = 'All'
            this.reportForm.fund = 'All'
            this.reportForm.acctNoSfx = 'All'
            this.reportForm.dri = '1'
            this.reportForm.sortOrder = ''
            this.reportForm.subTotal = ''
            this.reportForm.pageBreak = ''
            this.reportForm.typeReport = 'D'
            this.reportForm.displayTrans = false
            this.reportForm.rptParam = true
          }
        } catch (err) {
          throw err
        }
      }
    },
    customValidation() {
      if (this.items.length === 0) {
        this.$toast.error('No sorting order selected for report.')
        return false
      }
      return true
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (!this.customValidation()) return
          // this.doSortOrder()
          this.processExport()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.export
      if (apiURI) {
        this.submitting = true
        let sortOrders = []
        for (let i in this.items) {
          sortOrders.push(
            this.getSeqKeyTitle(this.phNewSortHtml[i].children[1].innerHTML) +
              ':' +
              this.phNewSortHtml[i].children[2].innerHTML +
              ':' +
              this.phNewSortHtml[i].children[3].innerHTML
          )
        }
        this.reportForm.sortOrder = sortOrders.join()
        try {
          await this.$http.post(apiURI, this.reportForm)
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    getSeqKeyTitle(seqKey) {
      switch (seqKey) {
        case 'Agent':
          return 'acctNo1'
        case 'Branch':
          return 'branch'
        case 'Department':
          return 'dept'
        case 'Direct / RI Inwards':
          return 'dri'
        case 'Fund':
          return 'fund'
        case 'Policy Type':
          return 'polType'
        case 'Underwriting Year':
          return 'uwYr'
        case 'Transaction Type':
          return 'tranType'
        default:
          return ''
      }
    },
    doHelplist(field) {
      this.helplist = true
      switch (field) {
        case 'branch': {
          this.branchHelplist = true
          break
        }
        case 'dept': {
          this.deptHelplist = true
          break
        }
        case 'polType': {
          this.polTypeHelplist = true
          break
        }
        case 'fund': {
          this.fundHelplist = true
          break
        }
        case 'acctNoSfx': {
          this.suffixHelplist = true
          break
        }
        case 'sortOrder': {
          this.origList = this.items
          this.sortOrderHelplist = true
          break
        }
        default: {
          this.helplist = false
          this.branchHelplist = false
          this.deptHelplist = false
          this.polTypeHelplist = false
          this.fundHelplist = false
          this.suffixHelplist = false
          this.sortOrderHelplist = false
          break
        }
      }
    },
    doAssign(data) {
      if (this.branchHelplist) {
        this.reportForm.branch = []
        this.reportForm.branch = data.finalSelectedItems.toString()
      }
      if (this.deptHelplist) {
        this.reportForm.dept = []
        this.reportForm.dept = data.finalSelectedItems.toString()
      }
      if (this.polTypeHelplist) {
        this.reportForm.polType = []
        this.reportForm.polType = data.finalSelectedItems.toString()
      }
      if (this.fundHelplist) {
        this.reportForm.fund = []
        this.reportForm.fund = data.finalSelectedItems.toString()
      }
      if (this.suffixHelplist) {
        this.reportForm.acctNoSfx = []
        this.reportForm.acctNoSfx = data.finalSelectedItems.toString()
      }
      this.helplist = false
      this.branchHelplist = false
      this.deptHelplist = false
      this.polTypeHelplist = false
      this.fundHelplist = false
      this.suffixHelplist = false
    },
    doSortOrderList(sortOrderList) {
      this.items = []
      this.items = sortOrderList
      var sortOrderHtml = this.$refs['sortOrder'].$el.firstElementChild.firstElementChild.tBodies[0]
      Sortable.create(sortOrderHtml, {
        group: 'sortOrder', // group of data
        sort: true, // default allow to sort the table lst
        swapThreshold: 0.65, // the threshold position to swap the element
        delay: 1000, // time in milliseconds to define when the sorting should start
        delayOnTouchOnly: true, // only delay if user is using touch
        handle: '.phSortIcon', // to make this class to handle the sort
        animation: 150 // animation
      })
      this.doClose()
    },
    // doSortOrder() {
    //   let strSortOrder = ''
    //   let strSubTotal = ''
    //   let strPageBreak = ''
    //   let k = 0
    //   this.items.forEach(data => {
    //     strSortOrder += data.value
    //     strSubTotal += data.subTotal ? 1 : 0
    //     strPageBreak += data.pageBreak ? 1 : 0
    //     if (k !== this.items.length - 1) {
    //       strSortOrder += ','
    //       strSubTotal += ','
    //       strPageBreak += ','
    //       k++
    //     }
    //   })
    //   this.reportForm.sortOrder = strSortOrder
    //   this.reportForm.subTotal = strSubTotal
    //   this.reportForm.pageBreak = strPageBreak
    // },
    processRptKey(rptKey) {
      this.resetMessages()
      // For the Report Job History only
      JSON.parse(rptKey, (key, value) => {
        switch (key) {
          case 'fromDate': {
            this.reportForm.fromDate = new Date(value)
            break
          }
          case 'toDate': {
            this.reportForm.toDate = new Date(value)
            break
          }
          case 'branch': {
            this.reportForm.branch = value
            break
          }
          case 'dept': {
            this.reportForm.dept = value
            break
          }
          case 'polType': {
            this.reportForm.polType = value
            break
          }
          case 'fund': {
            this.reportForm.fund = value
            break
          }
          case 'acctNoSfx': {
            this.reportForm.acctNoSfx = value
            break
          }
          case 'dri': {
            this.reportForm.dri = value
            break
          }
          case 'sortOrder': {
            this.reportForm.sortOrder = value
            break
          }
          case 'subTotal': {
            this.reportForm.subTotal = value
            break
          }
          case 'pageBreak': {
            this.reportForm.pageBreak = value
            break
          }
          case 'typeReport': {
            this.reportForm.typeReport = value
            break
          }
          case 'displayTrans': {
            this.reportForm.displayTrans = value
            break
          }
          case 'rptParam': {
            this.reportForm.rptParam = value
            break
          }
          case 'format': {
            this.reportForm.format = value
            break
          }
          default: {
            break
          }
        }
      })
      this.processSortOrderList()
    },
    processSortOrderList() {
      const defList = [
        { id: 0, text: 'Agent', value: 'acctNo1', subTotal: false, pageBreak: false },
        { id: 1, text: 'Branch', value: 'branch', subTotal: false, pageBreak: false },
        { id: 2, text: 'Department', value: 'dept', subTotal: false, pageBreak: false },
        { id: 3, text: 'Direct / RI Inwards', value: 'dri', subTotal: false, pageBreak: false },
        { id: 4, text: 'Fund', value: 'fund', subTotal: false, pageBreak: false },
        { id: 5, text: 'Policy Type', value: 'polType', subTotal: false, pageBreak: false },
        { id: 6, text: 'Underwriting Year', value: 'uwYr', subTotal: false, pageBreak: false },
        { id: 7, text: 'Transaction Type', value: 'tranType', subTotal: false, pageBreak: false }
      ]
      let selectedList = []
      const sortOrderList = this.reportForm.sortOrder.split(',')
      const subTotalList = this.reportForm.subTotal.split(',')
      const pageBreakList = this.reportForm.pageBreak.split(',')
      this.items = []
      sortOrderList.forEach(data => {
        defList.forEach(sortOrder => {
          if (data === sortOrder.value) {
            selectedList.push(sortOrder)
          }
        })
      })
      for (let i = 0; i < selectedList.length; i++) {
        selectedList[i].subTotal = subTotalList[i] === '1'
        selectedList[i].pageBreak = pageBreakList[i] === '1'
      }
      this.items = []
      selectedList.map(data => {
        return this.items.push(data)
      })
      this.items = this.items
    },
    doClose(rptKey) {
      if (rptKey !== undefined && rptKey !== null) {
        this.processRptKey(rptKey)
      }
      this.helplist = false
      this.rptHistory = false
      // transition purpose
      setTimeout(() => {
        this.sortOrderHelplist = false
      }, 500)
    },
    doCloseHelpList(rptKey) {
      this.helplist = false
      this.branchHelplist = false
      this.deptHelplist = false
      this.polTypeHelplist = false
      this.fundHelplist = false
      this.suffixHelplist = false
    },
    doDisplayTrans() {
      if (this.reportForm.typeReport === 'S') {
        this.reportForm.displayTrans = false
      }
    },
    formatBoolean(xBoolean) {
      return xBoolean ? 'Yes' : 'No'
    },
    clone(arr) {
      return clone(arr)
    }
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.uwReports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    },
    directRIList() {
      return [
        { label: 'Both', value: 'B' },
        { label: 'Direct', value: '1' },
        { label: 'RI Inwards', value: '0' }
      ]
    },
    typeReportList() {
      return [
        { label: 'Both', value: 'B' },
        { label: 'Details', value: 'D' },
        { label: 'Summary', value: 'S' }
      ]
    },
    booleanList() {
      return [
        { label: 'Yes', value: true },
        { label: 'No', value: false }
      ]
    },
    displayTransAE() {
      return this.reportForm.typeReport === 'S'
    },
    phNewSortHtml() {
      if (this.items.length === 0) {
        return ''
      } else {
        return this.$refs['sortOrder'].$el.firstElementChild.firstElementChild.tBodies[0].rows
      }
    }
  },
  watch: {
    supportedList(value) {
      if (value && value.length > 0) {
        // Default the 1st value
        this.reportForm.format = value[0].value
      }
    }
  },
  components: {
    BranchHelplist,
    DeptHelplist,
    PolTypeHelplist,
    FundHelplist,
    AcctNoSfxHelplist,
    SortOrderHelplist
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>

<style></style>
